// @flow
import { componentFactory } from '../component-factory';

export const Footer = componentFactory('footer', () => ({
  color: '#66707c',
  padding: '16px',
  textAlign: 'center',
}));
